import { Button } from "@/components/Button/button.component";
import { ButtonComponentProps } from "@/components/Button/button.props";

import { card } from "../../card.style";

export type CardLinkProps = ButtonComponentProps;

const CardLink = ({ ...buttonProps }: CardLinkProps) => {
    const { link } = card({});

    return (
        <div className={link()}>
            <Button {...buttonProps} />
        </div>
    );
};

export { CardLink };
